import bfpIconPng from "../assets/BfpIcon.png";

import { createBitmapIcon } from "./createBitmapIcon";

export const BfpIcon = createBitmapIcon({
  alt: "Bfp",
  displayName: "BfpIcon",
  src: bfpIconPng,
});
